import React from 'react';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import QueueIcon from '@material-ui/icons/RecentActors';

import { CreateButton } from 'react-admin';

const QueueEmpty = ({ basePath, resource }) => (
  <Box textAlign="center" m={1}>
    <QueueIcon style={{ fontSize: 140 }} />
    <Typography variant="h4" paragraph>
      No queue available yet.
    </Typography>
    <Typography variant="body1">Do you want to add one?</Typography>
    <CreateButton className="primary" basePath={basePath} />
  </Box>
);

export default QueueEmpty;
